module.exports = __webpack_public_path__ + "img/search.4b5c1634.svg";